import React, { useState, useEffect, useCallback } from "react";
import api, { apiError } from "../api";
import { toast } from "sonner";
import { AjutorButton } from "../AjutorButton";

const box = { fontFamily: "Arial, sans-serif", fontSize: "12px", color: "#000000", background: "#ffffff" };
const titleStyle = { fontWeight: "bold", fontSize: "16px", marginBottom: "16px" };
const btnRed = { fontFamily: "Arial", fontSize: "12px", background: "#cc0000", color: "#fff", fontWeight: "bold", border: "1px solid #cc0000", padding: "6px 12px", cursor: "pointer" };
const thStyle = { border: "1px solid #000", padding: "4px 6px", textAlign: "left", background: "#f0f0f0", fontWeight: "bold" };
const tdStyle = { border: "1px solid #000", padding: "4px 6px" };

export default function ProformeEmise() {
  const [orders, setOrders] = useState([]);
  const [downloadingId, setDownloadingId] = useState(null);

  const loadOrders = useCallback(async () => {
    try {
      const { data } = await api.get("/lead-orders/orders");
      setOrders(data.items || []);
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => { loadOrders(); }, [loadOrders]);

  const downloadProforma = async (orderId, proformaNo) => {
    if (!orderId) return;
    setDownloadingId(orderId);
    try {
      const res = await api.get(`/lead-orders/order/${orderId}/proforma.pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Yvola_proforma_${proformaNo}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(apiError(e, "Eroare la descarcarea proformei"));
    } finally { setDownloadingId(null); }
  };

  return (
    <div style={{ ...box, padding: "24px", minHeight: "100%" }} data-testid="proforme-emise-page">
      <AjutorButton file="ajutor_proforme.pdf" />
      <h1 style={titleStyle}>PROFORME EMISE</h1>
      {orders.length === 0
        ? <div style={{ fontSize: "11px" }}>Nu exista proforme emise inca.</div>
        : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
            <thead>
              <tr>
                <th style={thStyle}>Nr. proforma</th>
                <th style={thStyle}>Data</th>
                <th style={thStyle}>Contacte</th>
                <th style={thStyle}>Total EUR</th>
                <th style={thStyle}>Total RON</th>
                <th style={thStyle}>PDF</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.order_id} data-testid={`proforma-row-${o.proforma_no}`}>
                  <td style={tdStyle}>{o.proforma_no || "-"}</td>
                  <td style={tdStyle}>{o.created_at ? o.created_at.slice(0, 10) : "-"}</td>
                  <td style={tdStyle}>{o.qty}</td>
                  <td style={tdStyle}>{o.total_eur != null ? o.total_eur : o.amount}</td>
                  <td style={tdStyle}>{o.total_ron != null ? o.total_ron : "-"}</td>
                  <td style={tdStyle}>
                    {o.proforma_no
                      ? <button style={btnRed} onClick={() => downloadProforma(o.order_id, o.proforma_no)} disabled={downloadingId === o.order_id} data-testid={`download-proforma-${o.proforma_no}`}>
                          {downloadingId === o.order_id ? "..." : "Descarca PDF"}
                        </button>
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
    </div>
  );
}
